import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { useMsal } from "@azure/msal-react";
import { InteractionStatus } from '@azure/msal-browser';
import { useState, useEffect } from "react";
import { loginRequest } from "../auth";

export default function useAzureToken() {
  const { instance, inProgress, accounts } = useMsal();
  const [token, setToken] = useState<string>();
  useEffect(() => {
    if (inProgress !== InteractionStatus.None || accounts.length === 0) {
      // MSAL non prêt, ignorez ou affichez loader via JSX
      return;
    }
    const activeAccount = instance.getActiveAccount();
    if (!activeAccount && accounts.length > 0) {
      // Définit le compte actif s'il n'est pas déjà défini
      instance.setActiveAccount(accounts[0]);
    }
    const accessTokenRequest = {
      scopes: loginRequest.scopes,
      account: accounts[0],
    };
    console.log('accessTokenRequest:', accessTokenRequest);
    instance
      .acquireTokenSilent(accessTokenRequest)
      .then((accessTokenResponse) => {
        console.log('accessTokenResponse:', accessTokenResponse);
        // Acquire token silent success
        const accessToken = accessTokenResponse.accessToken;
        console.log('Access Token acquired silently:', accessToken);
        // Call your API with token
        setToken(accessToken);
      })
      .catch((error) => {
        if (error instanceof InteractionRequiredAuthError) {
          instance.acquireTokenRedirect(accessTokenRequest);
        }
        console.log(error);
      });
  }, [instance, accounts, inProgress]);

  return token
}